<div class="splash">
    <div class="row align-items-center">
        <div class="col-sm-5 col-md-4 offset-md-2 col-lg-3 offset-lg-2">

            <div class="row">
                <div class="col">
                    <img src="images/deloitte.svg" alt="Deloitte" class="splash__logo mb-3" />
                </div>
            </div>

            <div class="row mb-5 pt-4">
                <div class="col">
                    <p class="splash__title">
                        {{businessFunction?.displayName}}
                    </p>
                    <p class="text-muted textBody--md mt-0 mb-4">Please sign in</p>

                    <form class="form" [formGroup]="loginFormGroup" (ngSubmit)="signInClicked(loginFormGroup.value, loginFormGroup.valid)" novalidate>
                        <div class="form-group">
                            <label class="text-white" for="username">Username</label>
                            <input placeholder="Enter your username" class="form-control" name="username" type="text" formControlName="username" autocomplete="off" />
                        </div>

                        <div class="form-group">
                            <label class="text-white" for="password">Password</label>
                            <input placeholder="Enter your password" class="form-control" name="password" type="password" formControlName="password" autocomplete="off" />
                        </div>
                        <div class="form__input-group mt-4">
                            <button class="btn btn-block btn-info" type="submit" [disabled]="!loginFormGroup.valid && !loggingIn">
                                {{loggingIn ? "Signing In..." : "Sign In"}}
                                <i class="fa fa-sign-in"></i>
                            </button>
                        </div>
                    </form>
                </div>
            </div>

            <div class="row pt-5">

                <div class="col">
                    <p>
                        <a [routerLink]="['/' + this.defaultRoute + '/passwordresetrequest']">Forgotten my password</a>
                    </p>
                    <small> Need assistance? | <a href="mailto:{{ businessFunction?.email }}?subject={{ businessFunction?.displayName }} - Login Enquiry">Contact us</a></small>
                </div>
            </div>
        </div>

        <div class="col-sm-7 col-md-6">
            <div class="splash__image">
                <img src="/images/globe.jpg" />
            </div>
        </div>
    </div>
</div>
